import { render, staticRenderFns } from "./KeyMetrics.vue?vue&type=template&id=2267c0e7&scoped=true"
import script from "./KeyMetrics.vue?vue&type=script&lang=js"
export * from "./KeyMetrics.vue?vue&type=script&lang=js"
import style0 from "./KeyMetrics.vue?vue&type=style&index=0&id=2267c0e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267c0e7",
  null
  
)

export default component.exports